import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Modal, Row, Col, Space, message } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import axios from 'axios';
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string
    check_in_user_name: undefined | string
    check_in_phone: undefined | string
    check_in_status: number | undefined
    room_number: string | undefined
    question_type: number | undefined
    questionDate: any
    checkInDate: any
    checkOutDate: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        check_in_status: undefined,
        room_number: undefined,
        question_type: undefined,
        questionDate: null,
        checkInDate: null,
        checkOutDate: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])
    // 汇总数据
    const [summaryData, setSummaryData] = useState<any>([])

    const [checkInVisible, setCheckInVisible] = useState<boolean>(false)
    const [checkOutVisible, setCheckOutVisible] = useState<boolean>(false)
    const [detailData, setDetailData] = useState<any>({})

    const [customerName, setCustomerName] = useState<string>()
    const [customerPhone, setCustomerPhone] = useState<string>()

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleDate = (param: any, attr: string, realDateParams: string[]) => {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        // 清空汇总数据
        setSummaryData("")

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'questionDate', ['question_start_day', 'question_end_day'])
        handleDate(params, 'checkInDate', ['check_in_start_day', 'check_in_end_day'])
        handleDate(params, 'checkOutDate', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/keeper/data_report/customer_question/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)

                // 设置汇总列表数据
                const { question_summary } = response
                if (question_summary && question_summary.length) {
                    setSummaryData(question_summary)
                }
            }

            setLoading(false)
        })
    }

    const exportExcel = (vlue: number) => {
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (!params.store_id) {
            return message.error('请选择要查询的门店')
        }

        if (!params.questionDate) {
            return message.error('请选择要查询的日期')
        }

        handleDate(params, 'questionDate', ['question_start_day', 'question_end_day'])
        handleDate(params, 'checkInDate', ['check_in_start_day', 'check_in_end_day'])
        handleDate(params, 'checkOutDate', ['check_out_start_day', 'check_out_end_day'])

        params['question_type'] = vlue

        baseAxiosComplete('/keeper/data_report/customer_question/export', {
            params: {
                ...iPagination,
                ...params
            }
        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 数据报表 -> 客户调查问卷表 */}
        <BreadCrumb position={['管家中心', '客户调查问卷表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores
                        placeholder="门店"
                        value={fetchOtherParams.store_id}
                        onChange={(v: string) => {
                            handleChange(v, 'store_id')
                        }}
                    />
                </div>

                <RangePicker style={{ marginRight: 8, marginBottom: 12 }} className="fl" placeholder={["问卷开始日期", "问卷结束日期"]} value={fetchOtherParams.questionDate} onChange={(v: any) => { handleChange(v, 'questionDate') }} />
                <Select allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 130 }} placeholder="问卷类型" value={fetchOtherParams.question_type} onChange={(v: number) => { handleChange(v, 'question_type') }}>
                    <Option value={1} key={1}>入住首周问卷</Option>
                    <Option value={2} key={2}>离所前问卷</Option>
                </Select>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />

                {/* <Select allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 150 }} placeholder="入住状态" value={fetchOtherParams.check_in_status} onChange={(v: number) => { handleChange(v, 'check_in_status') }}>
                    <Option value={1} key={1}>已预订</Option>
                    <Option value={2} key={2}>已入住</Option>
                    <Option value={3} key={3}>已出所</Option>
                </Select>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["入所开始日期", "入所结束日期"]} value={fetchOtherParams.checkInDate} onChange={(v: any) => { handleChange(v, 'checkInDate') }} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["出所开始日期", "出所结束日期"]} value={fetchOtherParams.checkOutDate} onChange={(v: any) => { handleChange(v, 'checkOutDate') }} /> */}
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel(1) }} type="dashed" >导出入所问卷</Button>}
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel(2) }} type="dashed" >导出离所问卷</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table rowKey="check_in_id" loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="查看" fixed render={(v: any) => {
                    return (<Button onClick={() => {
                        setCustomerName(v.check_in_user_name)
                        setCustomerPhone(v.check_in_phone)

                        baseAxiosNoInfo('/keeper/data_report/customer_question/detail', {
                            params: {
                                question_id: v.question_id
                            }

                        }).then((res: any) => {
                            res && setDetailData(res)
                        })

                        if (v.question_type === 1) {
                            setCheckInVisible(true)
                        } else {
                            setCheckOutVisible(true)
                        }

                    }} type="dashed" size="small">查看</Button>)
                }} />

                <Column title="问卷日期" fixed dataIndex="question_date" key="question_date" />
                <Column title="问卷类型" fixed dataIndex="question_type_desc" key="question_type_desc" />
                <Column title="客户姓名" fixed dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="客户手机号" fixed dataIndex="check_in_phone" key="check_in_phone" />
                <Column title="入住门店" dataIndex="check_in_store_name" key="check_in_store_name" />
                <Column title="入住状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
                <Column title="入所日期" dataIndex="check_in_time" key="check_in_time" />
                <Column title="出所日期" dataIndex="check_out_time_finally" key="check_out_time_finally" />
                <Column title="入住天数" dataIndex="check_in_total_days" key="check_in_total_days" />
                <Column title="入住信息" dataIndex="room_number" key="room_number" />
                <Column title="创建时间" dataIndex="question_time" key="question_time" />
            </Table>
        </div>

        {/* 汇总数据 */}
        <div className="common-main">
            <h3>汇总</h3>

            <Table dataSource={summaryData} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                <Column title="门店" dataIndex="check_in_store_name" key="check_in_store_name" />
                <Column title="入所问卷数量" dataIndex="check_in_question_count" key="check_in_question_count" />
                <Column title="离所问卷数量" dataIndex="check_out_question_count" key="check_out_question_count" />
            </Table>
        </div>

        {/* 入所问卷弹窗 */}
        <Modal title="调查问卷" visible={checkInVisible} footer={false} onCancel={() => { setCheckInVisible(false) }} width={600} bodyStyle={{ padding: '20px 30px' }}>
            <div style={{ textAlign: 'center', marginBottom: 15 }}>
                <h2>入住首周问卷</h2>
            </div>

            <Row gutter={24}>
                <Col span={24}>
                    <h3 style={{ marginBottom: 10, color: '#1890ff' }}>客户信息</h3>
                </Col>

                <Col xs={8}>
                    <div style={{ marginBottom: 5 }}>
                        <label>客户姓名：{customerName}</label>
                    </div>
                </Col>
                <Col xs={12}>
                    <div style={{ marginBottom: 5 }}>
                        <label>客户手机号：{customerPhone}</label>
                    </div>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={24}>
                    <h3 style={{ marginBottom: 10, color: '#1890ff' }}>问卷信息</h3>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>选择禧月荟理由：{detailData.reasons_desc}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>了解禧月荟渠道：{detailData.channel}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>了解渠道描述：{detailData.channel_desc ? detailData.channel_desc : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>实际感受服务：{detailData.expected}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>实际服务建议：{detailData.expected_suggest ? detailData.expected_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>入住体验服务：{detailData.experience_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>入住服务建议：{detailData.experience_service_suggest ? detailData.experience_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>前期咨询服务：{detailData.consult_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>前期服务建议：{detailData.consult_service_suggest ? detailData.consult_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>环境配套满意度：{detailData.environment}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>环境配套建议：{detailData.environment_suggest ? detailData.environment_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>管家服务评价：{detailData.minion_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>管家服务建议：{detailData.minion_service_suggest ? detailData.minion_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师服务评价：{detailData.nursing_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师服务建议：{detailData.nursing_service_suggest ? detailData.nursing_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士服务评价：{detailData.nurse_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士服务建议：{detailData.nurse_service_suggest ? detailData.nurse_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>营养膳食服务：{detailData.dietary_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>营养膳食建议：{detailData.dietary_service_suggest ? detailData.dietary_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>擦澡洗头服务：{detailData.wash_bath_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>擦澡洗头建议：{detailData.wash_bath_service_suggest ? detailData.wash_bath_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>服务建议：{detailData.service_suggest}</label>
                    </div>
                </Col>
            </Row>
        </Modal>

        {/* 离所问卷弹窗 */}
        <Modal title="调查问卷" visible={checkOutVisible} footer={false} onCancel={() => { setCheckOutVisible(false) }} width={600} bodyStyle={{ padding: '20px 30px' }}>
            <div style={{ textAlign: 'center', marginBottom: 15 }}>
                <h2>离所前问卷</h2>
            </div>

            <Row gutter={24}>
                <Col span={24}>
                    <h3 style={{ marginBottom: 10, color: '#1890ff' }}>客户信息</h3>
                </Col>

                <Col xs={8}>
                    <div style={{ marginBottom: 5 }}>
                        <label>客户姓名：{customerName}</label>
                    </div>
                </Col>
                <Col xs={12}>
                    <div style={{ marginBottom: 5 }}>
                        <label>客户手机号：{customerPhone}</label>
                    </div>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={24}>
                    <h3 style={{ marginBottom: 10, color: '#1890ff' }}>问卷信息</h3>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>整体服务满意度：{detailData.overall_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>整体服务建议：{detailData.overall_service_suggest ? detailData.overall_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>是否再选禧月荟：{detailData.revisit}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>是否推荐亲友：{detailData.is_recommend}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>管家服务满意度：{detailData.minion_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>管家服务建议：{detailData.minion_service_suggest ? detailData.minion_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师服务评价：{detailData.nursing_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师服务建议：{detailData.nursing_service_suggest ? detailData.nursing_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师工作态度：{detailData.nursing_work}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师工作建议：{detailData.nursing_work_suggest ? detailData.nursing_work_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师日常照护：{detailData.nursing_care}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师照护建议：{detailData.nursing_care_suggest ? detailData.nursing_care_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师护理卫生：{detailData.nursing_hygiene}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护理师护理建议：{detailData.nursing_hygiene_suggest ? detailData.nursing_hygiene_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士服务满意度：{detailData.nurse_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士服务建议：{detailData.nurse_service_suggest ? detailData.nurse_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士沟通能力：{detailData.nurse_interflow}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士沟通建议：{detailData.nurse_interflow_suggest ? detailData.nurse_interflow_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士工作态度：{detailData.nurse_work}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>护士工作建议：{detailData.nurse_work_suggest ? detailData.nurse_work_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>产后修复服务：{detailData.repair_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>产后修复建议：{detailData.repair_service_suggest ? detailData.repair_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>乳房护理服务：{detailData.breast_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>乳房护理建议：{detailData.breast_service_suggest ? detailData.breast_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>擦澡洗头服务：{detailData.wash_bath_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>擦澡洗头建议：{detailData.wash_bath_service_suggest ? detailData.wash_bath_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>餐食营养均衡：{detailData.meal_dietary}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>餐食营养建议：{detailData.meal_dietary_suggest ? detailData.meal_dietary_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>食材新鲜度：{detailData.food_freshness}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>食材新鲜度建议：{detailData.food_freshness_suggest ? detailData.food_freshness_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>菜品口感满意度：{detailData.menu_taste}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>菜品口感建议：{detailData.menu_taste_suggest ? detailData.menu_taste_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>营养师工作能力：{detailData.dietician_work}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>营养师工作建议：{detailData.dietician_work_suggest ? detailData.dietician_work_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>送餐时效满意度：{detailData.food_delivery}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>送餐时效建议：{detailData.food_delivery_suggest ? detailData.food_delivery_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>生活服务满意度：{detailData.life_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>生活服务建议：{detailData.life_service_suggest ? detailData.life_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>会所设施设备：{detailData.facilities}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>会所设施建议：{detailData.facilities_suggest ? detailData.facilities_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>配套物品满意度：{detailData.supporting_items}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>配套物品建议：{detailData.supporting_items_suggest ? detailData.supporting_items_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>来访安全管控：{detailData.visit_safety}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>来访安全建议：{detailData.visit_safety_suggest ? detailData.visit_safety_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>妈妈课堂安排：{detailData.mom_class}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>妈妈课堂建议：{detailData.mom_class_suggest ? detailData.mom_class_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>增值服务满意度：{detailData.add_service}</label>
                    </div>
                </Col>
                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>增值服务建议：{detailData.add_service_suggest ? detailData.add_service_suggest : '--'}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>最希望改进服务：{detailData.service_improve}</label>
                    </div>
                </Col>

                <Col xs={24}>
                    <div style={{ marginBottom: 5 }}>
                        <label>服务建议：{detailData.service_suggest ? detailData.service_suggest : '--'}</label>
                    </div>
                </Col>
            </Row>
        </Modal>
    </div>)
}